import { type LDFlagValue } from 'launchdarkly-js-client-sdk';

// Add new feature flags to this const
export const FEATURE_FLAG = {
  AI_AUDIENCES: 'aiAudiences',
  AI_DIGEST_NEXT: 'aiDigestNext',
  MCP_SERVER: 'mcpServer',
  STACK_ADAPT: 'stackAdapt',
} as const;

export type FEATURE_FLAG = keyof typeof FEATURE_FLAG;

export type FEATURE_FLAG_VALUE = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];

export type C99FlagSet = Record<FEATURE_FLAG_VALUE, LDFlagValue>;
